import WithRender from "../../templates/base/packingPreview.html";

import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([""]),
    visibleClass2D: function () {
      return this.preview3D ? "" : "visible";
    },
    visibleClass3D: function () {
      return this.preview3D ? "visible" : "";
    }
  },
  methods: {
    ...mapActions(["setActivePreview"]),
    togglePreview: function (value) {
      this.preview3D = value;
      this.setActivePreview(value ? "preview3D" : "preview2D");
    }
  },
  data: function () {
    return {
      preview3D: true
    };
  }
});
